// extracted by css-extract-rspack-plugin
export default {"root":"root-DuFCKn","active":"active-NfGrQc","badge":"badge-xEVO_7"};